import { render, staticRenderFns } from "./serviceType.vue?vue&type=template&id=4530e00c&scoped=true&"
import script from "./serviceType.vue?vue&type=script&lang=js&"
export * from "./serviceType.vue?vue&type=script&lang=js&"
import style0 from "./serviceType.vue?vue&type=style&index=0&id=4530e00c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530e00c",
  null
  
)

export default component.exports